import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ViewEncapsulation, OnChanges, DoCheck, Renderer2 } from '@angular/core';
import { INgxMyDpOptions, IMyDateModel, IMyDate, IMyInputFieldChanged, NgxMyDatePicker } from 'ngx-mydatepicker';
// import { Date } from 'core-js';

@Component({
    selector: 'date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./my-datepicker.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DatePicker implements OnInit, DoCheck, OnChanges {

    showClearBtn: boolean = false;
    @Input() date: any;
    @Input() disabled: boolean = false;
    @Input() inline: boolean;
    @Input("format") format: any = {};
    @Input() hasDefault: boolean = true;

    @Output() dateChange = new EventEmitter();

    @ViewChild('dp') ngxdp;

    ScrollListener;
    EscListener;

    SelectorStatus: boolean = false;
    myOptions: INgxMyDpOptions = {};

    constructor(private renderer: Renderer2) { }

    //@HostListener('keyup.escape', ['$event'])
    //handleEscapeEvent(event: KeyboardEvent) {
    //    if (this.inline) {
    //        event.preventDefault();
    //        event.stopImmediatePropagation();
    //        event.stopPropagation();
    //        this.ngxdp.openCalendar();
    //    }
    //}
    


    ngOnInit() {
        // debugger;
        if (this.date == undefined && (this.format.setDefault == undefined || this.format.setDefault) && this.hasDefault) {
            let now = new Date();
            this.date = {date:{year:now.getUTCFullYear(), month: now.getUTCMonth() + 1, day: now.getUTCDate()}};
            //this.dateChange.emit(this.ParseObjectDate(this.date.date));
        }
        if (this.date && this.date != "" && this.date instanceof Date)
            this.date = this.ParseInitDate(this.date);
        // set the configuration options for the calender
        this.NgxMyDpOptions()
        if (this.inline) {
            this.ngxdp.openCalendar();
        }
    }

    ngOnChanges() {
        this.NgxMyDpOptions();

        this.ngxdp.opts = this.myOptions;
        
        if (this.date && this.date != "" && this.date instanceof Date) {
            this.date = this.ParseInitDate(this.date);
        }

        if (this.inline) {
            this.EscListener = this.renderer.listen('window', 'keyup.escape', (event) => {
                if (this.inline) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    this.ngxdp.openCalendar();
                }
            });
            setTimeout(() => {
                this.ngxdp.closeCalendar();
                this.ngxdp.openCalendar();
            }, 10)
        }
    }

    ngDoCheck() {
        if (!this.inline) {
            if (this.date == "" || this.date == undefined) {
                this.showClearBtn = false;
            }
            else {
                this.showClearBtn = true;
            }
        }
    }

    NgxMyDpOptions() { // set configurations option of the calender from the sent options the user added or the default values
        this.myOptions.dayLabels = this.format.dayLabels ?
            this.format.dayLabels : { su: 'Sun', mo: 'Mon', tu: 'Tue', we: 'Wed', th: 'Thu', fr: 'Fri', sa: 'Sat' };
        this.myOptions.monthLabels = this.format.monthLabels ?
            this.format.monthLabels : { 1: 'Jan', 2: 'Feb', 3: 'Mar', 4: 'Apr', 5: 'May', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Oct', 11: 'Nov', 12: 'Dec' };
        this.myOptions.dateFormat = this.format.dateFormat ?
            this.format.dateFormat : "dd-mm-yyyy";
        this.myOptions.showTodayBtn = this.format.showTodayBtn ?
            this.format.showTodayBtn : true;
        this.myOptions.todayBtnTxt = this.format.todayBtnTxt ?
            this.format.todayBtnTxt : "Today";
        this.myOptions.firstDayOfWeek = this.format.firstDayOfWeek ?
            this.format.firstDayOfWeek : 'sa';
        this.myOptions.satHighlight = this.format.satHighlight ?
            this.format.satHighlight : false;
        this.myOptions.sunHighlight = this.format.sunHighlight ?
            this.format.sunHighlight : false;
        this.myOptions.highlightDates = this.format.highlightDates ?
            this.format.highlightDates : [];
        this.myOptions.markCurrentDay = this.format.markCurrentDay ?
            this.format.markCurrentDay : true;
        this.myOptions.markCurrentMonth = this.format.markCurrentMonth ?
            this.format.markCurrentMonth : true;
        this.myOptions.markCurrentYear = this.format.markCurrentYear ?
            this.format.markCurrentYear : true;
        this.myOptions.monthSelector = this.format.monthSelector ?
            this.format.monthSelector : true;
        this.myOptions.yearSelector = this.format.yearSelector ?
            this.format.yearSelector : true;
        this.myOptions.disableHeaderButtons = this.format.disableHeaderButtons ?
            this.format.disableHeaderButtons : true;
        this.myOptions.showWeekNumbers = this.format.showWeekNumbers ?
            this.format.showWeekNumbers : false;
        this.myOptions.selectorHeight = this.format.selectorHeight ?
            this.format.selectorHeight : '232px';
        this.myOptions.selectorWidth = this.format.selectorWidth ?
            this.format.selectorWidth : '252px';
        this.myOptions.disableUntil = this.format.disableUntil ?
            this.format.disableUntil : { year: 0, month: 0, day: 0 };
        this.myOptions.disableSince = this.format.disableSince ?
            this.format.disableSince : { year: 0, month: 0, day: 0 };
        this.myOptions.disableDates = this.format.disableDates ?
            this.format.disableDates : [{ year: 0, month: 0, day: 0 }];
        this.myOptions.enableDates = this.format.enableDates ?
            this.format.enableDates : [{ year: 0, month: 0, day: 0 }];
        this.myOptions.markDates = this.format.markDates ?
            this.format.markDates : [];
        this.myOptions.markWeekends = this.format.markWeekends ?
            this.format.markWeekends : { marked: false, color: '' };
        this.myOptions.disableDateRanges = this.format.disableDateRanges ?
            this.format.disableDateRanges : [];
        this.myOptions.disableWeekends = this.format.disableWeekends ?
            this.format.disableWeekends : false;
        this.myOptions.disableWeekdays = this.format.disableWeekdays ?
            this.format.disableWeekdays : [];
        this.myOptions.alignSelectorRight = this.format.alignSelectorRight ?
            this.format.alignSelectorRight : false;
        this.myOptions.openSelectorTopOfInput = this.format.openSelectorTopOfInput ?
            this.format.openSelectorTopOfInput : false;
        this.myOptions.closeSelectorOnDateSelect = this.format.closeSelectorOnDateSelect ?
            this.format.closeSelectorOnDateSelect : this.inline ? false : true;
        this.myOptions.closeSelectorOnDocumentClick = this.format.closeSelectorOnDocumentClick ?
            this.format.closeSelectorOnDocumentClick : this.inline ? false : true;
        this.myOptions.minYear = this.format.minYear ?
            this.format.minYear : 1000;
        this.myOptions.maxYear = this.format.maxYear ?
            this.format.maxYear : 9999;
        this.myOptions.showSelectorArrow = this.format.showSelectorArrow ?
            this.format.showSelectorArrow : this.inline ? false : true;
        this.myOptions.allowSelectionOnlyInCurrentMonth = this.format.allowSelectionOnlyInCurrentMonth ?
            this.format.allowSelectionOnlyInCurrentMonth : true;
        this.myOptions.appendSelectorToBody = this.format.appendSelectorToBody ?
            this.format.appendSelectorToBody : this.inline ? false : true;
        this.myOptions.ariaLabelPrevMonth = this.format.ariaLabelPrevMonth ?
            this.format.ariaLabelPrevMonth : 'Previous Month';
        this.myOptions.ariaLabelNextMonth = this.format.ariaLabelNextMonth ?
            this.format.ariaLabelNextMonth : 'Next Month';
        this.myOptions.ariaLabelPrevYear = this.format.ariaLabelPrevYear ?
            this.format.ariaLabelPrevYear : 'Previous Year';
        this.myOptions.ariaLabelNextYear = this.format.ariaLabelNextYear ?
            this.format.ariaLabelNextYear : 'Next Year';

    }

    private ParseInitDate(date: Date) {
        const d = date.getDate();
        const m = date.getMonth() + 1;
        const y = date.getFullYear();
        return {
            date: { year: y, month: m, day: d }
        }
    }

    onDateChangedf(e) {
        this.dateChange.emit(e.jsdate);
    }

    private ParseObjectDate(dateObject: IMyDate): string {
        let dateStr = new Date(dateObject.year.toString() + '-' + dateObject.month.toString() + '-' + dateObject.day.toString()).toString();
        return dateStr;
    }

    // private ParseJSDate(): IMyDate {

    // }
    openCalender() {
        if (!this.inline) {

            this.ScrollListener = this.renderer.listen('window', 'mousewheel', (event) => {
                if (this.SelectorStatus) {
                    this.ngxdp.closeCalendar();
                    this.ScrollListener();
                }
                this.SelectorStatus = false;
            });


            let h = this.ngxdp.opts.selectorHeight.replace('px', '');
            
            if ((window.screen.height - this.ngxdp.elem.nativeElement.getBoundingClientRect().top) - 165 < parseInt(h)) {
                // this.myOptions.openSelectorTopOfInput = true;   
                // this.format.openSelectorTopOfInput = true;    
                this.ngxdp.opts.openSelectorTopOfInput = true;
                this.ngxdp.opts.showSelectorArrow = false;
            }
            else {
                //this.myOptions.openSelectorTopOfInput = false;      
                this.ngxdp.opts.openSelectorTopOfInput = false;
                this.ngxdp.opts.showSelectorArrow = true;
            }
            this.SelectorStatus = !this.SelectorStatus;
        }
        else {
            this.SelectorStatus = true;
        }
        this.ngxdp.toggleCalendar();
       
    }
    
    clearDate(): void {
        this.ngxdp.clearDate();
        this.dateChange.emit();
    }
    openMonths(){
        //this.selectYear = false;
            this.ngxdp.cdr.detectChanges();
            //if (this.selectMonth) {
                var today = this.ngxdp.getToday();
                this.ngxdp.months.length = 0;
                for (var i = 1; i <= 12; i += 3) {
                    var row = [];
                    for (var j = i; j < i + 3; j++) {
                        var disabled = this.ngxdp.utilService.isMonthDisabledByDisableUntil({ year: this.ngxdp.visibleMonth.year, month: j, day: this.ngxdp.daysInMonth(j, this.ngxdp.visibleMonth.year) }, this.ngxdp.opts.disableUntil)
                            || this.ngxdp.utilService.isMonthDisabledByDisableSince({ year: this.ngxdp.visibleMonth.year, month: j, day: 1 }, this.ngxdp.opts.disableSince);
                        row.push({ nbr: j, name: this.ngxdp.opts.monthLabels[j], currMonth: j === today.month && this.ngxdp.visibleMonth.year === today.year, selected: j === this.ngxdp.visibleMonth.monthNbr, disabled: disabled });
                    }
                    this.ngxdp.months.push(row);
                }
            //}
    }
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/DatePicker/date-picker.component.ts